import { c as _c } from "react/compiler-runtime";
import { styled } from '@precis-digital/kurama/utils';
import Tabs, { Tab } from '@precis-digital/kurama/Tabs';
import type { ReactElement, SyntheticEvent } from 'react';
import { CARD_TYPE_TO_ICON, CHART_CARD_TYPE_TO_NUMBER, NUMBER_TO_CHART_CARD_TYPE } from '../../constants';
import type { ChangeCardType } from '../../internalTypes';
import type { ChartCardType } from '../../types';
const ChartTableSwap = t0 => {
  const $ = _c(6);
  const {
    cardType,
    changeCardType,
    otherCardTypes
  } = t0;
  let t1;
  if ($[0] !== changeCardType) {
    t1 = (_, newValue) => {
      changeCardType(NUMBER_TO_CHART_CARD_TYPE[newValue]);
    };
    $[0] = changeCardType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChangeCardType = t1;
  let t2;
  if ($[2] !== cardType || $[3] !== handleChangeCardType || $[4] !== otherCardTypes) {
    const cardTypes = [...otherCardTypes, cardType].sort(_temp);
    t2 = <Tabs key="changeCardType" currentTab={CHART_CARD_TYPE_TO_NUMBER[cardType]} handleChange={handleChangeCardType}>{cardTypes.map(_temp2)}</Tabs>;
    $[2] = cardType;
    $[3] = handleChangeCardType;
    $[4] = otherCardTypes;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
const StyledTab = styled(Tab)({
  minWidth: 'initial'
});
export default ChartTableSwap;
function _temp(a, b) {
  return CHART_CARD_TYPE_TO_NUMBER[a] - CHART_CARD_TYPE_TO_NUMBER[b];
}
function _temp2(cardType_0, index) {
  const Icon = CARD_TYPE_TO_ICON[cardType_0];
  return <StyledTab value={index} key={cardType_0}><Icon /></StyledTab>;
}